import type { RouteHandler } from '../../lib/types';
// Internal platform admin routes (backend §57, §89). Rendered in the separate 'admin' layout.
import * as overview from './overview';
import * as orgs from './orgs';
import * as catalog from './catalog';
import * as ops from './ops';
import * as billing from './billing';
import * as sitemap from './sitemap';
import * as architecture from './architecture';
import * as marketplace from './marketplace';
import * as tenancy from './tenancy';
import * as knowledge from './knowledge';
import { renderDetail as runDetail } from '../runs';

export const routes: Array<[string, RouteHandler['page'], string]> = [
  ['/admin', overview.render, 'overview'],
  ['/admin/tenancy', tenancy.render, 'tenancy'],
  ['/admin/sitemap', sitemap.render, 'sitemap'],
  ['/admin/architecture', architecture.render, 'architecture'],
  ['/admin/knowledge', knowledge.render, 'knowledge'],
  ['/admin/organizations', orgs.renderList, 'organizations'],
  ['/admin/organizations/:orgId', orgs.renderDetail, 'organizations'],
  ['/admin/users', orgs.renderUsers, 'users'],
  ['/admin/nodes', catalog.renderNodes, 'nodes'],
  ['/admin/nodes/:typeId', catalog.renderNodeType, 'nodes'],
  ['/admin/providers', catalog.renderProviders, 'providers'],
  ['/admin/providers/:providerId', catalog.renderProvider, 'providers'],
  ['/admin/executions', catalog.renderLibrary, 'executions'],
  ['/admin/library', catalog.renderLibrary, 'executions'],
  ['/admin/templates', catalog.renderTemplates, 'templates'],
  ['/admin/marketplace', marketplace.render, 'marketplace'],
  ['/admin/runs', ops.renderRuns, 'runs'],
  ['/admin/runs/:runId', runDetail, 'runs'],
  ['/admin/failed-runs', ops.renderFailed, 'failed'],
  ['/admin/queue', ops.renderQueue, 'queue'],
  ['/admin/workers', ops.renderWorkers, 'workers'],
  ['/admin/integrations', ops.renderIntegrations, 'integrations'],
  ['/admin/usage', billing.renderUsage, 'usage'],
  ['/admin/flags', billing.renderFlags, 'flags'],
  ['/admin/audit', billing.renderAudit, 'audit'],
  ['/admin/system', billing.renderSystem, 'system'],
];
